import {
    Panel, Select, SelectOption, Button, Tooltip, Table,
} from 'appkit-react';
import { Row, Col, Alert } from 'react-bootstrap';

import AddDomainModalContainer from '../containers/AddDomainModalContainer';

const AdminPanel = ({
    selectedUser, setSelectedUser, users, getApiKey, createAPIKeyLoading,
    showApiKeyAlert, setShowApiKeyAlert, showApiKey, apiKeyResult,
    isApiKeyCopied, copyApiKey, setShowApiKey, visible, setVisible,
    refetchUserInfo, domains, columns, tenantId,
}) => (
    <Panel
        title="Settings"
        className="a-increase-child-color-level-by-1"
        style={{ marginTop: '1rem', marginBottom: '2rem' }}
    >
        <Row style={{ marginTop: '1rem' }}>
            <Col md={2}>
                <Select
                    placeholder="Select user"
                    onSelect={e => { setSelectedUser(e); }}
                    showSearchOnList
                    value={selectedUser}
                    name="selectedUser"
                >
                    {
                        users && users.data
                        && users.data.getUsers.map(user => (
                            <SelectOption
                                key={user.userId}
                                value={user.userId}
                            >
                                {user.fullName}
                            </SelectOption>
                        ))
                    }
                </Select>
            </Col>
            <Col md={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
                <Button
                    size="lg"
                    kind="secondary"
                    onClick={() => getApiKey()}
                    isLoading={createAPIKeyLoading}
                    disabled={!selectedUser}
                >
                    Regenerate API key
                </Button>
            </Col>
            <Col style={{ paddingLeft: 0 }} className="api-key-alert">
                {(showApiKeyAlert && !createAPIKeyLoading)
                    && (
                        <Alert
                            variant="success"
                            onClose={() => setShowApiKeyAlert(false)}
                            style={{
                                marginBottom: 0, height: '2.3rem', padding: 0, paddingLeft: '1rem', paddingBootom: '1rem',
                            }}
                        >
                            {'API key : '}
                            <span className="a-h6" style={{ color: '#155724' }}>
                                {showApiKey
                                    && (
                                        <span className="show-api-key">
                                            {apiKeyResult}
                                        </span>
                                    )}

                                {!showApiKey
                                    && (
                                        <span className="api-key-ellipsis">
                                            ...........................................
                                        </span>
                                    )}

                                <span
                                    style={{ marginLeft: '2rem' }}
                                >
                                    <Tooltip
                                        content={showApiKey ? 'Hide' : 'Show'}
                                        placement="top"
                                        tooltipTheme="light"
                                        style={{ display: 'inline-block' }}
                                    >
                                        <span
                                            style={{
                                                float: 'right',
                                                lineHeight: '1.5rem',
                                                cursor: 'pointer',
                                                fontSize: '0.8rem',
                                                marginTop: '0.8rem',
                                                paddingRight: '1rem',
                                                marginRight: '1rem',
                                            }}
                                            className="appkiticon
                                            icon-view-fill"
                                            onClick={() => setShowApiKey(prevState => !prevState)}
                                            role="presentation"
                                        />
                                    </Tooltip>
                                    <Tooltip
                                        content={
                                            isApiKeyCopied ? 'Copied!' : 'Copy'
                                        }
                                        placement="top"
                                        tooltipTheme="light"
                                        style={{ display: 'inline-block' }}
                                    >
                                        <span
                                            style={{
                                                float: 'right',
                                                lineHeight: '1.5rem',
                                                cursor: 'pointer',
                                                fontSize: '0.7rem',
                                                marginTop: '0.8rem',
                                                paddingRight: '1rem',
                                            }}
                                            className="appkiticon icon-duplicate-fill"
                                            onClick={() => copyApiKey(apiKeyResult)}
                                            role="presentation"
                                        />
                                    </Tooltip>
                                </span>
                            </span>
                            <span
                                style={{
                                    float: 'right', lineHeight: '1.5rem', cursor: 'pointer', fontSize: '0.7rem', marginTop: '0.8rem', paddingRight: '1rem',
                                }}
                                className="appkiticon icon-close-fill"
                                onClick={() => setShowApiKeyAlert(false)}
                                role="presentation"
                            />
                        </Alert>
                    )}
                {(showApiKeyAlert && !createAPIKeyLoading)
                    && (
                        <div className="api-key-warning">
                            API Key will be visible only one time. Please note it down.
                        </div>
                    )}
            </Col>
        </Row>

        <hr />

        <Row style={{ marginTop: '1rem' }}>
            <Col>
                <h6>White Listed Domains</h6>
            </Col>
            <Col md={2}>
                <span style={{ float: 'right', paddingBottom: '0.2rem' }}>
                    <Button size="md" kind="secondary" onClick={() => { setVisible(true); }}> ADD NEW  </Button>
                </span>
            </Col>
        </Row>

        {visible && <AddDomainModalContainer visible={visible} setVisible={setVisible} refetchUserInfo={refetchUserInfo} tenantId={tenantId} />}

        <div style={{ paddingTop: '0.1rem', paddingBottom: '1rem', marginBottom: '2rem' }}>
            <Table
                data={domains || []}
                columns={columns}
                defaultPageSize={10}
                sortable
                size="lg"
                resizable
                showPageSizeOptions={false}
            />
        </div>
    </Panel>
);

export default AdminPanel;
